import React, { useCallback } from 'react'
import { BookingForm } from 'pages/bookings/BookingForm'
import { PromptModal } from 'components'
import { useHistory, useParams, Redirect } from 'react-router-dom'
import { useBooking, useUpdateBooking } from 'api'
import { useTranslation } from 'react-i18next'

interface RouteParams {
  bookingId: string
}

export const EditBookingPage = () => {
  const { t } = useTranslation()

  const history = useHistory()
  const navigateToOverview = useCallback(() => history.push('/bookings'), [
    history,
  ])
  const { bookingId } = useParams<RouteParams>()
  const { data: booking } = useBooking(parseInt(bookingId, 10))
  const [mutate, { status, reset }] = useUpdateBooking()
  const onSubmit = useCallback(
    async (values, { setSubmitting }) => {
      mutate({ bookingId: parseInt(bookingId, 10), booking: values })
      setSubmitting(false)
    },
    [mutate, bookingId]
  )
  if (booking && booking.status === 'CANCELLED') {
    return <Redirect to={`/bookings/${bookingId}`} />
  }

  return (
    <>
      <h1>{t('pages.bookings.editBookingPage.heading')}</h1>

      {booking && <BookingForm onSubmit={onSubmit} booking={booking} />}

      {status === 'success' && (
        <PromptModal
          headline={t('pages.bookings.editBookingPage.success.headline')}
          confirmCallback={navigateToOverview}
          confirmText={t('pages.bookings.editBookingPage.success.confirm')}
        >
          {t('pages.bookings.editBookingPage.success.message')}
        </PromptModal>
      )}

      {status === 'failure' && (
        <PromptModal
          headline={t('pages.bookings.editBookingPage.failure.headline')}
          confirmCallback={reset}
          confirmText={t('pages.bookings.editBookingPage.failure.confirm')}
        >
          {t('pages.bookings.editBookingPage.failure.message')}
        </PromptModal>
      )}
    </>
  )
}
